import ErrorMessage from "components/ErrorMessage";
import Page from "components/Page";
import { useTranslation } from "react-i18next";

export const GenericErrorPage = () => {
  const { t } = useTranslation();

  return (
    <Page>
      <ErrorMessage
        title={t("order.error.generic.title")}
        description={t("order.error.generic.description")}
      />
    </Page>
  );
};

export default GenericErrorPage;
